import React, {useEffect, useState} from 'react';
import ResizableBox, {sumValue} from "../../utils/ResizableBox";
import {Bar} from "react-chartjs-2";
import axios from "axios";
import {BASE_NAME} from "../../../../../services/utils/ApiUrls";
import moment from "moment";
import {getConfig} from "../../../../../services/utils/ConfigUtils";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {Backdrop, Card, CardContent, CardHeader, CircularProgress, Typography} from "@mui/material";
import clsx from "clsx";
import {colors} from "../../../../../utils/arrays/Generics";

const options = {
	plugins: {
		title: {
			display: true,
			text: 'Vaccini per giorno per tipo'
		},
	},
	responsive: true,
	scales: {
		x: {
			stacked: true,
		},
		y: {
			stacked: true
		}
	}
};

export const VacciniGiornoStato = () => {
	const classes = BaseStyle();
	const [dataGrafico, setDataGrafico] = useState(new Date());
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({
		labels: ['01/12/2021'],
		datasets: [
			{
				label: 'I love you',
				data: [3000],
				backgroundColor: 'rgba(255, 99, 132, 0.5)',
				stack: 'Stack 0',
			},
		],
	})
	
	useEffect(() => {
		setDataGrafico(new Date())
	}, [])
	
	useEffect(() => {
		setLoading(true);
		axios
			.get(BASE_NAME + "vaccinazioni/getStatsByDayAndType/" + moment(dataGrafico).format("DD-MM-YYYY"), getConfig())
			.then((response) => {
				
				let sorted = response.data.sort((a, b) => {
					if (new Date(a.label) < new Date(b.label)) {
						return -1;
					}
					if (new Date(a.label) > new Date(b.label)) {
						return 1;
					}
					return 0;
				})
				
				let labels = [...new Set(sorted.map(item => moment(new Date(item.label)).format("DD/MM/YYYY")))];
				
				
				let newData1 = {
					labels: labels,
					datasets: [
						{
							label: "prime_dosi",
							data: sumValue(sorted, labels, "prime_dosi"),
							//data: sorted.map(sortElem => sumValue(sortElem.data, sortElem.type, "prime_dosi")),
							backgroundColor: colors[0],
							stack: 'Stack 0',
						},
						{
							label: "seconde_dosi",
							data: sumValue(sorted, labels, "seconde_dosi"),
							//data: sorted.map(sortElem => sumValue(sortElem.data, sortElem.type, "seconde_dosi")),
							backgroundColor: colors[1],
							stack: 'Stack 0',
						},
						{
							label: "terze_dosi",
							data: sumValue(sorted, labels, "terze_dosi"),
							//data: sorted.map(sortElem => sumValue(sortElem.data, sortElem.type, "terze_dosi")),
							backgroundColor: colors[2],
							stack: 'Stack 0',
						}
					]
				}
				
				console.log(newData1)
				
				setData(newData1);
				setLoading(false)
			})
			.catch((error) => {
				setLoading(false);
				console.log(JSON.stringify(error))
			})
	}, [dataGrafico])
	
	return (
		<React.Fragment>
			<Backdrop open={loading} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Ticket giorno - stato</b></Typography>}
					subheader={"Numero di vaccini (asse y) per giorno (asse x) suddivisi per tipo (colore)"}
				/>
				<CardContent style={{flexGrow: 1, overflow: "scroll"}}>
					
					<ResizableBox width={1200} height={600}>
						<Bar options={options} data={data} type={"bar"}/>
					</ResizableBox>
				
				</CardContent>
			</Card>
		</React.Fragment>
	);
};
